import { customFormat, dateFormats, endOfYear, startOfYear, sub } from 'utils/dateUtils'

import { COMPANY_FILTER_CHANGE } from '../../PartnerOptions/constants'
import { SEGMENTS_REQUEST_ASYNC } from '../constants'

import { SELECT_ALL, UNSELECT_ALL } from './CheckboxCounterContainer/constants'
import { SELECT_TOGGLE, STATUS_TOGGLE_ASYNC, TAG_REMOVE_ASYNC } from './TableRow/constants'
import {
  ACTIVATE_SELECT_ALL,
  ADD_ASYNC,
  CHANGE_COMPLIANCE_REPORT_DATA,
  CLEAR_COMPLIANCE_REPORT_DATA,
  CREATE_COMPLIANCE_REPORT_ASYNC,
  DATA_REQUEST_ASYNC,
  EXPORT_FORMAT_VALUES,
  FETCH_MANAGEMENT_TAGS_ASYNC,
  FETCH_PROFILES_SUGGESTIONS_ASYNC,
  PAGINATE_CHANGE,
  PROTECTED_FILTER_CHANGE,
  REPORT_TYPE_VALUES,
  RISK_LEVELS_FILTER_CHANGE,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SEGMENTS_FILTER_CHANGE,
  SET_MANAGEMENT_TAGS_PAGE,
  SET_MANAGEMENT_TAGS_SEARCH,
  SORT_PROPERTY_CHANGE,
  STATUSES_TOGGLE_ASYNC,
  TAGS_FILTER_CHANGE,
  TIME_PERIOD_VALUES,
  TYPE_FILTER_CHANGE,
} from './constants'

const defaultTagsObject = {
  items: [],
  page: 1,
  search: '',
  loader: false,
  error: null,
  totalPages: 1,
}

const DEFAULT_COMPLAINT_REPORT_DATA = {
  shareEmailOptions: [],
  recipients: [],
  timePeriodFilter: TIME_PERIOD_VALUES.LAST_YEAR,
  message: '',
  reportType: REPORT_TYPE_VALUES.SIMULATION_AND_TRAINING,
  exportFormatFilter: EXPORT_FORMAT_VALUES.CSV,
  startDate: `${customFormat(
    startOfYear(sub(new Date(), { years: 1 })),
    dateFormats.numbers
  )}T00:00:00`,
  endDate: `${customFormat(
    endOfYear(sub(new Date(), { years: 1 })),
    dateFormats.numbers
  )}T23:59:59`,
  loader: false,
  error: null,
}

export default function () {
  const initialState = {
    data: {
      count: 0,
      items: [],
    },
    page: 1,
    loader: false,
    error: null,
    search: '',
    sortProperty: '', // first_name-desc
    tagsError: [],
    typeFilter: 'enabled',
    protectedFilter: 'all',
    tagsFilter: [],
    tagsFilterLoader: false,
    segments: [],
    segmentsFilter: [],
    riskLevelsFilter: [],
    selectedMailboxesMap: {},
    loaderMailboxesMap: {},
    message: null,
    addMailboxStatus: false,
    addMailboxMessage: null,
    addMailboxLoader: false,
    selectAll: false,
    complianceReportData: DEFAULT_COMPLAINT_REPORT_DATA,
    tags: {
      ...defaultTagsObject,
    },
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case SEARCH_RESET:
        return {
          ...state,
          search: '',
        }
      case SEARCH_CHANGE:
        return {
          ...state,
          search: action.payload.q,
          loader: true,
          page: 1,
        }
      case SORT_PROPERTY_CHANGE:
        return {
          ...state,
          sortProperty: action.payload.value,
          loader: true,
        }
      case TAG_REMOVE_ASYNC.INITIATE:
        return {
          ...state,
          loaderMailboxesMap: {
            ...state.loaderMailboxesMap,
            [action.payload.id]: true,
          },
        }
      case TAG_REMOVE_ASYNC.SUCCESS: {
        const filteredByCurrentTag = !!state.tagsFilter.filter(
          (elem) => elem.label === action.payload.data.tagName
        ).length
        if (!filteredByCurrentTag) {
          return {
            ...state,
            data: {
              ...state.data,
              items: state.data.items.map((mailbox) => {
                if (mailbox.id !== action.payload.data.id) return mailbox
                else {
                  return {
                    ...mailbox,
                    tags: mailbox.tags.filter((tag) => tag.name !== action.payload.data.tagName),
                  }
                }
              }),
            },
            loaderMailboxesMap: {
              ...state.loaderMailboxesMap,
              [action.payload.data.id]: false,
            },
          }
        }
        return {
          ...state,
          data: {
            ...state.data,
            items: state.data.items.filter((e) => e.id !== action.payload.data.id),
          },
        }
      }
      case TAG_REMOVE_ASYNC.ERROR:
        return {
          ...state,
          loaderMailboxesMap: {
            ...state.loaderMailboxesMap,
            [action.payload.data.id]: true,
          },
        }
      case COMPANY_FILTER_CHANGE:
        return {
          ...state,
          page: 1,
          loader: true,
          error: null,
          search: '',
          sortProperty: '', // first_name-desc
          tagsFilterLoader: true,
          selectedMailboxesMap: {},
          loaderMailboxesMap: {},
          selectAll: false,
          data: {
            ...state.data,
            items: [],
          },
          tags: { ...defaultTagsObject },
        }
      case ACTIVATE_SELECT_ALL:
        return {
          ...state,
          selectAll: true,
        }
      case TAGS_FILTER_CHANGE:
        return {
          ...state,
          tagsFilter: action.payload.selectedTagsArray,
          page: 1,
          loader: true,
        }
      case SEGMENTS_FILTER_CHANGE:
        return {
          ...state,
          segmentsFilter: action.payload.selectedSegmentsArray,
          page: 1,
          loader: true,
        }
      case RISK_LEVELS_FILTER_CHANGE:
        return {
          ...state,
          riskLevelsFilter: action.payload.selectedRiskLevelsArray,
          page: 1,
          loader: true,
        }
      case TYPE_FILTER_CHANGE:
        return {
          ...state,
          typeFilter: action.payload.value,
          page: 1,
          loader: true,
        }
      case PROTECTED_FILTER_CHANGE:
        return {
          ...state,
          protectedFilter: action.payload.value,
          page: 1,
          loader: true,
        }
      case PAGINATE_CHANGE:
        return {
          ...state,
          page: action.payload.page,
          loader: true,
        }
      case DATA_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case DATA_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: action.payload.data,
          loader: false,
        }
      case DATA_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error }
      case DATA_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false, page: 1 }

      case SEGMENTS_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          // segments must stay an array (Header maps over it); guard against a
          // non-array body so a malformed/empty response degrades to "no
          // segments" instead of crashing the page on `.map`.
          segments: Array.isArray(action.payload.data) ? action.payload.data : [],
        }
      case SEGMENTS_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error }
      case SELECT_ALL: {
        return {
          ...state,
          selectedMailboxesMap: state.data.items.reduce(
            (prev, curr) => ({ ...prev, [curr.id]: true }),
            {}
          ),
        }
      }
      case UNSELECT_ALL: {
        return {
          ...state,
          selectedMailboxesMap: {},
          selectAll: false,
        }
      }
      case SELECT_TOGGLE: {
        if (state.selectedMailboxesMap[action.payload.id]) {
          delete state.selectedMailboxesMap[action.payload.id]
        } else {
          state.selectedMailboxesMap[action.payload.id] = true
        }
        return {
          ...state,
          selectedMailboxesMap: {
            ...state.selectedMailboxesMap,
          },
          selectAll: false,
        }
      }
      case STATUS_TOGGLE_ASYNC.INITIATE:
        return {
          ...state,
          loaderMailboxesMap: {
            ...state.loaderMailboxesMap,
            [action.payload.id]: true,
          },
        }
      case STATUS_TOGGLE_ASYNC.SUCCESS: {
        const id = Number(action.payload.data.id)
        return {
          ...state,
          loaderMailboxesMap: {
            ...state.loaderMailboxesMap,
            [id]: false,
          },
          data: {
            ...state.data,
            items: state.data.items.map((mailbox) => {
              if (mailbox.id !== id) return mailbox
              else {
                return {
                  ...mailbox,
                  tags: action.payload.data.tags,
                  active: action.payload.data.active,
                  protected: action.payload.data.protected,
                }
              }
            }),
          },
        }
      }
      case STATUS_TOGGLE_ASYNC.ERROR:
        return {
          ...state,
          loaderMailboxesMap: {
            ...state.loaderMailboxesMap,
            [action.payload.id]: false,
          },
        }
      case STATUS_TOGGLE_ASYNC.CANCEL:
        return {
          ...state,
          loaderMailboxesMap: {
            ...state.loaderMailboxesMap,
            [action.payload.id]: false,
          },
        }
      case STATUSES_TOGGLE_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
        }
      case STATUSES_TOGGLE_ASYNC.SUCCESS:
        return {
          ...state,
          selectedMailboxesMap: {},
          selectAll: false,
        }
      case STATUSES_TOGGLE_ASYNC.ERROR:
        return { ...state, loader: false }
      case ADD_ASYNC.INITIATE:
        return {
          ...state,
          addMailboxStatus: false,
          addMailboxLoader: true,
        }
      case ADD_ASYNC.SUCCESS:
        return {
          ...state,
          addMailboxStatus: action.payload.data.success,
          addMailboxLoader: false,
        }
      case ADD_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          addMailboxStatus: false,
          addMailboxLoader: false,
        }
      case ADD_ASYNC.CANCEL:
        return {
          ...state,
          addMailboxLoader: false,
          addMailboxStatus: false,
        }
      case FETCH_PROFILES_SUGGESTIONS_ASYNC.SUCCESS:
        return {
          ...state,
          complianceReportData: {
            ...state.complianceReportData,
            shareEmailOptions: action.payload.data.items.map(({ email }) => ({
              label: email,
              value: email,
            })),
          },
        }
      case CHANGE_COMPLIANCE_REPORT_DATA:
        return {
          ...state,
          complianceReportData: {
            ...state.complianceReportData,
            [action.payload.fieldName]: action.payload.value,
          },
        }
      case CLEAR_COMPLIANCE_REPORT_DATA:
        return {
          ...state,
          complianceReportData: DEFAULT_COMPLAINT_REPORT_DATA,
        }
      case CREATE_COMPLIANCE_REPORT_ASYNC.INITIATE:
        return {
          ...state,
          complianceReportData: {
            ...state.complianceReportData,
            loader: true,
            error: null,
          },
        }
      case CREATE_COMPLIANCE_REPORT_ASYNC.SUCCESS:
        return {
          ...state,
          complianceReportData: DEFAULT_COMPLAINT_REPORT_DATA,
        }
      case CREATE_COMPLIANCE_REPORT_ASYNC.ERROR:
        return {
          ...state,
          complianceReportData: {
            ...state.complianceReportData,
            loader: false,
            error: action.error,
          },
        }
      case FETCH_MANAGEMENT_TAGS_ASYNC.INITIATE:
        return {
          ...state,
          tagsFilterLoader: true,
          tags: {
            ...state.tags,
            loader: true,
            error: null,
          },
        }
      case FETCH_MANAGEMENT_TAGS_ASYNC.SUCCESS: {
        const newItems = action.payload.data.tags?.reduce((acc, elem) => {
          acc[elem.id] = {
            name: elem.name,
            id: elem.id,
            type: elem.auto_tag_type,
          }
          return acc
        }, {})

        return {
          ...state,
          tagsError: null,
          tagsFilterLoader: false,
          tagsFilter: [],
          tags: {
            ...state.tags,
            items: { ...state.tags.items, ...newItems },
            totalPages: action.payload.data.lastPageNum,
            loader: false,
          },
        }
      }
      case FETCH_MANAGEMENT_TAGS_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          tags: {
            ...state.tags,
            loader: false,
            error: action.error,
          },
        }
      case FETCH_MANAGEMENT_TAGS_ASYNC.CANCEL:
        return {
          ...state,
          tagsFilterLoader: false,
          tags: {
            ...state.tags,
            loader: false,
          },
        }
      case SET_MANAGEMENT_TAGS_PAGE:
        return {
          ...state,
          tags: {
            ...state.tags,
            page: action.payload.page,
          },
        }
      case SET_MANAGEMENT_TAGS_SEARCH:
        return {
          ...state,
          tags: {
            ...state.tags,
            page: 1,
            search: action.payload.search,
          },
        }
      default:
        return state
    }
  }
}
